const defaultState = {
    items: null,
    actionStatus: null
}

export default defaultState;